import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/text-to-prompt/page.tsx");
